var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.getCustomer()}}},[_vm._v(_vm._s(_vm.params.data.Email_Address))])}
var staticRenderFns = []

export { render, staticRenderFns }